// County → sub-county → towns. Towns always include the sub-county HQ so the
// third dropdown is never empty. Existing values that are not in the list are
// still shown by the picker so saved data is not lost.
const KENYA_LOCATIONS = {
  Baringo: {
    'Baringo Central': ['Kabarnet', 'Tenges', 'Ewalel Chapchap'],
    'Baringo North': ['Kabartonjo', 'Bartabwa', 'Kipsaraman'],
    'Baringo South': ['Marigat', 'Mukutani', 'Mochongoi'],
    Mogotio: ['Mogotio', 'Emining', 'Kisanana'],
    'Eldama Ravine': ['Eldama Ravine', 'Lembus', 'Koibatek'],
    Tiaty: ['Nginyang', 'Chemolingot', 'Kolowa']
  },
  Bomet: {
    Sotik: ['Sotik', 'Ndanai', 'Kaplong'],
    Chepalungu: ['Sigor', 'Siongiroi', 'Chebunyo'],
    'Bomet East': ['Longisa', 'Kembu', 'Merigi'],
    'Bomet Central': ['Bomet', 'Silibwet', 'Mutarakwa'],
    Konoin: ['Mogogosiek', 'Boito', 'Kimulot']
  },
  Bungoma: {
    'Mt. Elgon': ['Kapsokwony', 'Kaptama', 'Cheptais'],
    Sirisia: ['Sirisia', 'Namwela', 'Malakisi'],
    Kabuchai: ['Chwele', 'Kabuchai', 'Mukuyuni'],
    Bumula: ['Bumula', 'Khasoko', 'South Bukusu'],
    Kanduyi: ['Bungoma', 'Musikoma', 'Bukembe'],
    'Webuye East': ['Webuye', 'Ndivisi', 'Mihuu'],
    'Webuye West': ['Bokoli', 'Sitikho', 'Matulo'],
    Kimilili: ['Kimilili', 'Kamukuywa', 'Maeni'],
    Tongaren: ['Tongaren', 'Ndalu', 'Soysambu']
  },
  Busia: {
    'Teso North': ['Amagoro', 'Angurai', 'Malaba'],
    'Teso South': ['Amukura', 'Chakol', 'Amukura Town'],
    Nambale: ['Nambale', 'Bukhayo', 'Tingolo'],
    Matayos: ['Busia', 'Matayos', 'Busibwabo'],
    Butula: ['Butula', 'Marachi', 'Elugulu'],
    Funyula: ['Funyula', 'Nangina', 'Ageng\'a'],
    Budalangi: ['Port Victoria', 'Bunyala', 'Khajula']
  },
  'Elgeyo-Marakwet': {
    'Marakwet East': ['Tot', 'Tirap', 'Sambirir'],
    'Marakwet West': ['Kapsowar', 'Lelan', 'Arror'],
    'Keiyo North': ['Iten', 'Tambach', 'Kapchemutwa'],
    'Keiyo South': ['Chepkorio', 'Metkei', 'Kabiemit']
  },
  Embu: {
    Manyatta: ['Embu', 'Manyatta', 'Itabua'],
    Runyenjes: ['Runyenjes', 'Kianjokoma', 'Kyeni'],
    'Mbeere South': ['Kiritiri', 'Gachoka', 'Mavuria'],
    'Mbeere North': ['Siakago', 'Evurore', 'Nthawa']
  },
  Garissa: {
    'Garissa Township': ['Garissa', 'Iftin', 'Township'],
    Balambala: ['Balambala', 'Danyere', 'Saka'],
    Lagdera: ['Modogashe', 'Benane', 'Sabena'],
    Dadaab: ['Dadaab', 'Dertu', 'Liboi'],
    Fafi: ['Bura East', 'Fafi', 'Jarajila'],
    Ijara: ['Masalani', 'Hulugho', 'Sangailu']
  },
  'Homa Bay': {
    Kasipul: ['Oyugis', 'Kasipul', 'East Kamagak'],
    'Kabondo Kasipul': ['Kabondo', 'Kosele', 'Kokwanyo'],
    Karachuonyo: ['Kendu Bay', 'Wang\'chieng', 'Kibiri'],
    Rangwe: ['Rangwe', 'Gembe', 'Kochia'],
    'Homa Bay Town': ['Homa Bay', 'Homa Bay Central', 'Homa Bay Arujo'],
    Ndhiwa: ['Ndhiwa', 'Kwabwai', 'Kanyamwa'],
    Mbita: ['Mbita', 'Rusinga', 'Mfangano'],
    Suba: ['Sindo', 'Gwassi', 'Central'],
  },
  Isiolo: {
    'Isiolo North': ['Isiolo', 'Oldonyiro', 'Ngaremara'],
    'Isiolo South': ['Garbatulla', 'Kinna', 'Sericho']
  },
  Kajiado: {
    'Kajiado North': ['Ngong', 'Ongata Rongai', 'Kiserian', 'Olkeri'],
    'Kajiado Central': ['Kajiado', 'Purko', 'Ildamat'],
    'Kajiado East': ['Kitengela', 'Isinya', 'Kaputiei North'],
    'Kajiado West': ['Ngatataek', 'Mosiro', 'Ewuaso Oonkidong\'i'],
    'Kajiado South': ['Loitokitok', 'Kimana', 'Rombo']
  },
  Kakamega: {
    Lugari: ['Lugari', 'Lumakanda', 'Chekalini'],
    Likuyani: ['Likuyani', 'Kongoni', 'Nzoia'],
    Malava: ['Malava', 'West Kabras', 'East Kabras'],
    Lurambi: ['Kakamega', 'Shieywe', 'Butsotso'],
    Navakholo: ['Navakholo', 'Bunyala', 'Ingotse'],
    'Mumias West': ['Mumias', 'Musanda', 'Etenje'],
    'Mumias East': ['Shianda', 'Lusheya', 'Malaha'],
    Matungu: ['Matungu', 'Koyonzo', 'Khalaba'],
    Butere: ['Butere', 'Marama', 'Shiakhungu'],
    Khwisero: ['Khwisero', 'Kisa', 'Mulwanda'],
    Shinyalu: ['Shinyalu', 'Isukha', 'Murhanda'],
    Ikolomani: ['Ikolomani', 'Idakho', 'Shikumu']
  },
  Kericho: {
    'Kipkelion East': ['Londiani', 'Kedowa', 'Chepseon'],
    'Kipkelion West': ['Kipkelion', 'Kunyak', 'Chilchila'],
    Ainamoi: ['Kericho', 'Kapsoit', 'Ainamoi'],
    Bureti: ['Litein', 'Kisiara', 'Cheplanget'],
    Belgut: ['Sosiot', 'Waldai', 'Kabianga'],
    'Sigowet/Soin': ['Sigowet', 'Soin', 'Soliat']
  },
  Kiambu: {
    'Gatundu South': ['Gatundu', 'Kiamwangi', 'Ndarugu'],
    'Gatundu North': ['Kamwangi', 'Gituamba', 'Mangu'],
    Juja: ['Juja', 'Kalimoni', 'Witeithie'],
    'Thika Town': ['Thika', 'Township', 'Kamenu'],
    Ruiru: ['Ruiru', 'Kahawa Sukari', 'Githurai', 'Mwihoko'],
    Githunguri: ['Githunguri', 'Ikinu', 'Komothai'],
    Kiambu: ['Kiambu', 'Riabai', 'Township'],
    Kiambaa: ['Karuri', 'Cianda', 'Ndenderu'],
    Kabete: ['Wangige', 'Kabete', 'Uthiru', 'Kikuyu Road'],
    Kikuyu: ['Kikuyu', 'Kinoo', 'Sigona'],
    Limuru: ['Limuru', 'Ngecha', 'Tigoni'],
    Lari: ['Lari', 'Kirenga', 'Kijabe']
  },
  Kilifi: {
    'Kilifi North': ['Kilifi', 'Tezo', 'Kibarani'],
    'Kilifi South': ['Mtwapa', 'Shimo la Tewa', 'Junju'],
    Kaloleni: ['Kaloleni', 'Mariakani', 'Kayafungo'],
    Rabai: ['Rabai', 'Kambe', 'Mwawesa'],
    Ganze: ['Ganze', 'Bamba', 'Jaribuni'],
    Malindi: ['Malindi', 'Shella', 'Jilore'],
    Magarini: ['Magarini', 'Gongoni', 'Marafa']
  },
  Kirinyaga: {
    Mwea: ['Wanguru', 'Kimbimbi', 'Mutithi'],
    Gichugu: ['Kianyaga', 'Kabare', 'Baragwi'],
    Ndia: ['Baricho', 'Kiine', 'Kariti'],
    'Kirinyaga Central': ['Kerugoya', 'Kutus', 'Inoi']
  },
  Kisii: {
    Bonchari: ['Suneka', 'Bomariba', 'Bogiakumu'],
    'South Mugirango': ['Nyamarambe', 'Boikanga', 'Tabaka'],
    'Bomachoge Borabu': ['Magenche', 'Boochi', 'Bomariba'],
    Bobasi: ['Nyacheki', 'Sameta', 'Bobasi Boitangare'],
    'Bomachoge Chache': ['Ogembo', 'Majoge', 'Boochi Borabu'],
    'Nyaribari Masaba': ['Masimba', 'Ichuni', 'Gesusu'],
    'Nyaribari Chache': ['Kisii', 'Keumbu', 'Kiogoro'],
    'Kitutu Chache North': ['Mosocho', 'Kegogi', 'Marani'],
    'Kitutu Chache South': ['Nyatieko', 'Bogeka', 'Kitutu']
  },
  Kisumu: {
    'Kisumu East': ['Manyatta', 'Kolwa', 'Kajulu'],
    'Kisumu West': ['Ojola', 'South West Kisumu', 'North Kisumu'],
    'Kisumu Central': ['Kisumu', 'Market Milimani', 'Railways', 'Migosi'],
    Seme: ['Kombewa', 'West Seme', 'East Seme'],
    Nyando: ['Ahero', 'Awasi', 'Kobura'],
    Muhoroni: ['Muhoroni', 'Chemelil', 'Miwani'],
    Nyakach: ['Pap Onditi', 'Nyakach', 'Holo']
  },
  Kitui: {
    'Mwingi North': ['Kyuso', 'Ngomeni', 'Tseikuru'],
    'Mwingi West': ['Migwani', 'Nguutani', 'Kiomo'],
    'Mwingi Central': ['Mwingi', 'Nuu', 'Waita'],
    'Kitui West': ['Kauwi', 'Mutonguni', 'Kwa Vonza'],
    'Kitui Rural': ['Kisasi', 'Mbitini', 'Yatta Kwa Vonza'],
    'Kitui Central': ['Kitui', 'Township', 'Mulango'],
    'Kitui East': ['Mutitu', 'Zombe', 'Endau'],
    'Kitui South': ['Ikutha', 'Mutomo', 'Ikanga']
  },
  Kwale: {
    Msambweni: ['Msambweni', 'Diani', 'Ukunda'],
    Lungalunga: ['Lunga Lunga', 'Vanga', 'Pongwe'],
    Matuga: ['Kwale', 'Tiwi', 'Waa'],
    Kinango: ['Kinango', 'Samburu', 'Ndavaya']
  },
  Laikipia: {
    'Laikipia West': ['Rumuruti', 'Ol-Moran', 'Sipili'],
    'Laikipia East': ['Nanyuki', 'Ngobit', 'Thingithu'],
    'Laikipia North': ['Doldol', 'Mukogodo', 'Ilngwesi']
  },
  Lamu: {
    'Lamu East': ['Faza', 'Kiunga', 'Kizingitini'],
    'Lamu West': ['Lamu', 'Mpeketoni', 'Hindi', 'Witu']
  },
  Machakos: {
    Masinga: ['Masinga', 'Ekalakala', 'Muthesya'],
    Yatta: ['Kithimani', 'Ikombe', 'Ndalani'],
    Kangundo: ['Kangundo', 'Tala', 'Matungulu Kangundo'],
    Matungulu: ['Tala', 'Kyeleni', 'Matungulu West'],
    Kathiani: ['Kathiani', 'Mitaboni', 'Lower Kaewa'],
    Mavoko: ['Athi River', 'Syokimau', 'Mlolongo', 'Kinanie'],
    'Machakos Town': ['Machakos', 'Mua', 'Mutituni'],
    Mwala: ['Mwala', 'Masii', 'Wamunyu']
  },
  Makueni: {
    Mbooni: ['Mbooni', 'Tulimani', 'Kisau'],
    Kilome: ['Kilome', 'Kiima Kiu', 'Mukaa'],
    Kaiti: ['Wote', 'Kee', 'Kilungu'],
    Makueni: ['Wote Town', 'Muvau', 'Kathonzweni'],
    'Kibwezi West': ['Makindu', 'Kikumbulyu', 'Nguumo'],
    'Kibwezi East': ['Kibwezi', 'Mtito Andei', 'Thange']
  },
  Mandera: {
    'Mandera West': ['Takaba', 'Dandu', 'Gither'],
    Banissa: ['Banissa', 'Derkhale', 'Kiliwehiri'],
    'Mandera North': ['Rhamu', 'Ashabito', 'Rhamu Dimtu'],
    'Mandera South': ['Elwak', 'Shimbir Fatuma', 'Wargadud'],
    'Mandera East': ['Mandera', 'Township', 'Neboi'],
    Lafey: ['Lafey', 'Waranqara', 'Alango Gof']
  },
  Marsabit: {
    Moyale: ['Moyale', 'Uran', 'Golbo'],
    'North Horr': ['North Horr', 'Dukana', 'Maikona'],
    Saku: ['Marsabit', 'Karare', 'Sagante'],
    Laisamis: ['Laisamis', 'Loiyangalani', 'Korr']
  },
  Meru: {
    'Igembe South': ['Maua', 'Kangeta', 'Athiru Gaiti'],
    'Igembe Central': ['Kangeta', 'Igembe East', 'Akirang\'ondu'],
    'Igembe North': ['Laare', 'Ndoleli', 'Antuambui'],
    'Tigania West': ['Urru', 'Mbeu', 'Nkomo'],
    'Tigania East': ['Mikinduri', 'Thangatha', 'Karama'],
    'North Imenti': ['Meru', 'Municipality', 'Ntima'],
    Buuri: ['Timau', 'Kisima', 'Kibirichia'],
    'Central Imenti': ['Githongo', 'Abothuguchi', 'Mwanganthia'],
    'South Imenti': ['Nkubu', 'Igoji', 'Mitunguu']
  },
  Migori: {
    Rongo: ['Rongo', 'Central Kamagambo', 'North Kamagambo'],
    Awendo: ['Awendo', 'South Sakwa', 'Central Sakwa'],
    'Suna East': ['Migori', 'God Jope', 'Suna Central'],
    'Suna West': ['Wasimbete', 'Wiga', 'Wasweta'],
    Uriri: ['Uriri', 'West Kanyamkago', 'Central Kanyamkago'],
    Nyatike: ['Macalder', 'Karungu', 'Got Kachola'],
    'Kuria West': ['Kehancha', 'Masaba', 'Bukira'],
    'Kuria East': ['Kegonga', 'Ntimaru', 'Nyabasi']
  },
  Mombasa: {
    Changamwe: ['Changamwe', 'Port Reitz', 'Kipevu', 'Airport'],
    Jomvu: ['Jomvu', 'Miritini', 'Mikindani'],
    Kisauni: ['Kisauni', 'Bamburi', 'Mtopanga', 'Shanzu'],
    Nyali: ['Nyali', 'Frere Town', 'Kongowea', 'Mkomani'],
    Likoni: ['Likoni', 'Mtongwe', 'Timbwani', 'Shika Adabu'],
    Mvita: ['Mombasa CBD', 'Old Town', 'Tudor', 'Tononoka', 'Majengo']
  },
  "Murang'a": {
    Kangema: ['Kangema', 'Kanyenya-ini', 'Rwathia'],
    Mathioya: ['Kiru', 'Kamacharia', 'Gitugi'],
    Kiharu: ["Murang'a", 'Township', 'Mbiri'],
    Kigumo: ['Kigumo', 'Kangari', 'Kinyona'],
    Maragwa: ['Maragua', 'Makuyu', 'Ichagaki'],
    Kandara: ['Kandara', 'Gaichanjiru', 'Ithiru'],
    Gatanga: ['Gatanga', 'Ithanga', 'Kakuzi']
  },
  Nairobi: {
    Westlands: ['Westlands', 'Parklands', 'Kangemi', 'Kitisuru', 'Highridge'],
    'Dagoretti North': ['Kilimani', 'Kileleshwa', 'Kawangware', 'Gatina'],
    'Dagoretti South': ['Mutu-ini', 'Ngando', 'Riruta', 'Uthiru/Ruthimitu'],
    Langata: ['Langata', 'Karen', 'Nairobi West', 'Mugumo-ini', 'South C'],
    Kibra: ['Kibra', 'Woodley', 'Sarang\'ombe', 'Lindi', 'Laini Saba'],
    Roysambu: ['Roysambu', 'Githurai', 'Kahawa', 'Zimmerman', 'Kahawa West'],
    Kasarani: ['Kasarani', 'Mwiki', 'Clay City', 'Njiru', 'Ruai'],
    Ruaraka: ['Ruaraka', 'Baba Dogo', 'Utalii', 'Mathare North', 'Lucky Summer'],
    'Embakasi South': ['Embakasi South', 'Imara Daima', 'Kwa Njenga', 'Kwa Reuben', 'Pipeline'],
    'Embakasi North': ['Embakasi North', 'Dandora', 'Kariobangi North'],
    'Embakasi Central': ['Embakasi Central', 'Kayole', 'Komarock', 'Matopeni'],
    'Embakasi East': ['Embakasi East', 'Upper Savanna', 'Lower Savanna', 'Utawala', 'Mihango'],
    'Embakasi West': ['Embakasi West', 'Umoja', 'Mowlem', 'Kariobangi South'],
    Makadara: ['Makadara', 'Maringo/Hamza', 'Viwandani', 'Harambee', 'Makongeni'],
    Kamukunji: ['Kamukunji', 'Pumwani', 'Eastleigh North', 'Eastleigh South', 'Airbase'],
    Starehe: ['CBD', 'Nairobi Central', 'Ngara', 'Pangani', 'Landimawe', 'Ziwani'],
    Mathare: ['Mathare', 'Huruma', 'Mlango Kubwa', 'Ngei', 'Kiamaiko']
  },
  Nakuru: {
    Molo: ['Molo', 'Elburgon', 'Turi'],
    Njoro: ['Njoro', 'Mau Narok', 'Kihingo'],
    Naivasha: ['Naivasha', 'Hell\'s Gate', 'Mai Mahiu', 'Karagita'],
    Gilgil: ['Gilgil', 'Elementaita', 'Murindati'],
    'Kuresoi South': ['Keringet', 'Amalo', 'Kiptagich'],
    'Kuresoi North': ['Kamara', 'Nyota', 'Sirikwa'],
    Subukia: ['Subukia', 'Mbogoini', 'Waseges'],
    Rongai: ['Rongai', 'Kampi ya Moto', 'Solai'],
    Bahati: ['Bahati', 'Lanet', 'Dundori'],
    'Nakuru Town West': ['Kaptembwo', 'Rhoda', 'Barut', 'London'],
    'Nakuru Town East': ['Nakuru CBD', 'Biashara', 'Kivumbini', 'Flamingo', 'Menengai']
  },
  Nandi: {
    Tinderet: ['Tinderet', 'Songhor', 'Nandi Hills South'],
    Aldai: ['Kobujoi', 'Terik', 'Kemeloi'],
    'Nandi Hills': ['Nandi Hills', 'Kapchorua', 'Ol\'lessos'],
    Chesumei: ['Chesumei', 'Kosirai', 'Chemundu'],
    Emgwen: ['Kapsabet', 'Kilibwoni', 'Kapkangani'],
    Mosop: ['Kabiyet', 'Ndalat', 'Sangalo']
  },
  Narok: {
    Kilgoris: ['Kilgoris', 'Keyian', 'Lolgorian'],
    'Emurua Dikirr': ['Emurua Dikirr', 'Ilkerin', 'Kapsasian'],
    'Narok North': ['Narok', 'Olokurto', 'Melili'],
    'Narok East': ['Nairegie Enkare', 'Mosiro', 'Ildamat'],
    'Narok South': ['Ololulung\'a', 'Sogoo', 'Loita'],
    'Narok West': ['Lemek', 'Mara', 'Ilmotiook']
  },
  Nyamira: {
    'Kitutu Masaba': ['Nyamira', 'Rigoma', 'Gachuba'],
    'West Mugirango': ['Nyamaiya', 'Bogichora', 'Bonyamatuta'],
    'North Mugirango': ['Ekerenyo', 'Itibo', 'Bomwagamo'],
    Borabu: ['Nyansiongo', 'Esise', 'Mekenene']
  },
  Nyandarua: {
    Kinangop: ['Engineer', 'Njabini', 'Githabai'],
    Kipipiri: ['Kipipiri', 'Wanjohi', 'Geta'],
    'Ol Kalou': ['Ol Kalou', 'Rurii', 'Kaimbaga'],
    'Ol Jorok': ['Ol Joro Orok', 'Gathanji', 'Charagita'],
    Ndaragwa: ['Ndaragwa', 'Shamata', 'Leshau']
  },
  Nyeri: {
    Tetu: ['Wamagana', 'Dedan Kimathi', 'Aguthi'],
    Kieni: ['Nairutia', 'Mweiga', 'Endarasha', 'Chaka'],
    Mathira: ['Karatina', 'Ruguru', 'Iriaini'],
    Othaya: ['Othaya', 'Chinga', 'Mahiga'],
    Mukurweini: ['Mukurweini', 'Rugi', 'Gikondi'],
    'Nyeri Town': ['Nyeri', 'Rware', 'Kamakwa', 'Kiganjo']
  },
  Samburu: {
    'Samburu West': ['Maralal', 'Porro', 'Loosuk'],
    'Samburu North': ['Baragoi', 'Nyiro', 'Angata Nanyukie'],
    'Samburu East': ['Wamba', 'Waso', 'Ndoto']
  },
  Siaya: {
    Ugenya: ['Ukwala', 'East Ugenya', 'North Ugenya'],
    Ugunja: ['Ugunja', 'Sidindi', 'Sigomere'],
    'Alego Usonga': ['Siaya', 'Township', 'Usonga'],
    Gem: ['Yala', 'Wagai', 'East Gem'],
    Bondo: ['Bondo', 'Nyawita', 'West Sakwa'],
    Rarieda: ['Madiany', 'Asembo', 'Uyoma']
  },
  'Taita-Taveta': {
    Taveta: ['Taveta', 'Chala', 'Mahoo', 'Bomani'],
    Wundanyi: ['Wundanyi', 'Werugha', 'Wumingu'],
    Mwatate: ['Mwatate', 'Bura', 'Ronge'],
    Voi: ['Voi', 'Mbololo', 'Ngolia', 'Kaloleni']
  },
  'Tana River': {
    Garsen: ['Garsen', 'Kipini', 'Tarasaa'],
    Galole: ['Hola', 'Chewele', 'Kinakomba'],
    Bura: ['Bura', 'Madogo', 'Bangale']
  },
  'Tharaka-Nithi': {
    Maara: ['Chogoria', 'Mwimbi', 'Mitheru'],
    'Chuka/Igambang\'ombe': ['Chuka', 'Karingani', 'Magumoni'],
    Tharaka: ['Marimanti', 'Chiakariga', 'Nkondi']
  },
  'Trans-Nzoia': {
    Kwanza: ['Kwanza', 'Keiyo', 'Bidii'],
    Endebess: ['Endebess', 'Chepchoina', 'Matumbei'],
    Saboti: ['Kitale', 'Kinyoro', 'Machewa'],
    Kiminini: ['Kiminini', 'Waitaluk', 'Sikhendu'],
    Cherangany: ['Cherangany', 'Suwerwa', 'Sitatunga']
  },
  Turkana: {
    'Turkana North': ['Lokitaung', 'Kaaleng', 'Lapur'],
    'Turkana West': ['Kakuma', 'Lokichoggio', 'Nanaam'],
    'Turkana Central': ['Lodwar', 'Kanamkemer', 'Kang\'atotha'],
    Loima: ['Lorugum', 'Turkwel', 'Loima'],
    'Turkana South': ['Lokichar', 'Katilu', 'Kaputir'],
    'Turkana East': ['Lokori', 'Kapedo', 'Kapedo/Napeitom']
  },
  'Uasin Gishu': {
    Soy: ['Soy', 'Ziwa', 'Kuinet'],
    Turbo: ['Turbo', 'Huruma', 'Kamagut'],
    Moiben: ['Moiben', 'Karuna', 'Sergoit'],
    Ainabkoi: ['Ainabkoi', 'Olare', 'Kapsoya'],
    Kapseret: ['Kapseret', 'Ngeria', 'Langas'],
    Kesses: ['Kesses', 'Cheptiret', 'Racecourse', 'Eldoret Town']
  },
  Vihiga: {
    Vihiga: ['Mbale', 'Vihiga', 'Lugaga'],
    Sabatia: ['Sabatia', 'Chavakali', 'Wodanga'],
    Hamisi: ['Hamisi', 'Shamakhokho', 'Banja'],
    Luanda: ['Luanda', 'Emabungo', 'Mwibona'],
    Emuhaya: ['Emuhaya', 'North East Bunyore', 'Central Bunyore']
  },
  Wajir: {
    'Wajir North': ['Bute', 'Buna', 'Korondile'],
    'Wajir East': ['Wajir', 'Township', 'Khorof/Harar'],
    Tarbaj: ['Tarbaj', 'Wargadud', 'Sarman'],
    'Wajir West': ['Griftu', 'Arbajahan', 'Hadado'],
    Eldas: ['Eldas', 'Della', 'Elnur'],
    'Wajir South': ['Habaswein', 'Diff', 'Lagboghol']
  },
  'West Pokot': {
    Kapenguria: ['Kapenguria', 'Mnagei', 'Siyoi'],
    Sigor: ['Sigor', 'Lomut', 'Wei Wei'],
    Kacheliba: ['Kacheliba', 'Alale', 'Kasei'],
    'Pokot South': ['Chepareria', 'Batei', 'Lelan']
  }
};

export const KENYA_COUNTIES = Object.keys(KENYA_LOCATIONS);

export function formatPlace({ town, subCounty, county, location } = {}) {
  const structured = [town, subCounty, county].filter(Boolean).join(', ');
  return structured || location || '';
}

export function getSubCounties(county) {
  return Object.keys(KENYA_LOCATIONS[county] || {});
}

export function getTowns(county, subCounty) {
  const listed = KENYA_LOCATIONS[county]?.[subCounty] || [];
  if (!subCounty) return [];
  if (!listed.includes(subCounty)) return [subCounty, ...listed];
  return listed;
}

export default KENYA_LOCATIONS;
